export function DurationOverlay({ seconds }: { seconds: number | null | undefined }) {
  if (!seconds || seconds <= 0) return null;
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  const text = `${m}:${String(s).padStart(2, "0")}`;
  return (
    <span className="absolute bottom-1 right-1 px-1 py-0.5 rounded bg-black/80 text-white text-xs font-medium">
      {text}
    </span>
  );
}